var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('img',{staticClass:"rounded-circle",style:(("width: " + _vm.size + "; height: " + _vm.size + ";")),attrs:{"src":_vm.avatar,"alt":_vm.alt},on:{"error":function($event){return _vm.onError($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }